import { PartIdentifier } from "./PartIdentifier";
import { buildProductionMethod } from "./CostStudyBuilder";

export class PurchaseCostKey {
  /**
   *
   * @param {{partId:string, recievingPlantNumber:string, productionMethodName:string}} key1
   * @param {{partId:string, recievingPlantNumber:string, productionMethodName:string}} key2
   * @returns
   */
  static compare = (key1, key2) => {
    return (
      PartIdentifier.compare(key1.partId, key2.partId) &&
      key1.recievingPlantNumber === key2.recievingPlantNumber &&
      key1.productionMethodName === key2.productionMethodName
    );
  };

  static buildKeyFromBomComponent = (component) => {
    let productionMethod = component.ProductionMethod;
    let recievingPlantNumber =
      productionMethod.value && productionMethod.value.receivingPlant.value
        ? productionMethod.value.receivingPlant.value.plantNumber
        : "";
    let productionMethodName = productionMethod.value
      ? productionMethod.value.method
      : "";
    return {
      partId: component.partId,
      productionMethodName,
      recievingPlantNumber,
    };
  };

  static buildKeyFromPurchase = (purchase) => {
    let productionMethod = buildProductionMethod(
      purchase.ProductionMethod?.Value?.Fields[0]
    );
    let recievingPlantNumber =
      productionMethod && productionMethod.receivingPlant
        ? productionMethod.receivingPlant.plantNumber
        : "";
    let productionMethodName = productionMethod ? productionMethod.method : "";
    return {
      partId: PartIdentifier.buildPartIdentifier(purchase.Part),
      productionMethodName,
      recievingPlantNumber,
    };
  };
}
